import React, {useState} from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {BOOLEAN_OPTIONS, COUNTRY_OPTIONS, MONTH_OPTIONS, YEAR_OPTIONS} from "../../../constants";
import SecondaryTitle from "../../../Components/SecondaryTitle";
import Text from "../../../Components/Text";
import DetaileddetailedLabel from "../../../Components/Forms/DetailedLabel";

const ResidentialAddressDetails = (props) => {
    const {
        data = {
            'residential_address_line_1':           '',
            'residential_address_line_2':           '',
            'residential_town_city':                '',
            'residential_state_county':             '',
            'residential_postcode':                 '',
            'residential_country':                  '',
            'residential_occupied_since_year':      '',
            'residential_occupied_since_month':     '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Permanent Residential Address</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_address_line_1'}
                        detailedLabel={'Address line 1'}
                        value={data.residential_address_line_1}
                        type={'text'}
                        onChange={(value) => onChange('residential_address_line_1', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        name={'residential_address_line_2'}
                        detailedLabel={'Address line 2'}
                        value={data.residential_address_line_2}
                        type={'text'}
                        onChange={(value) => onChange('residential_address_line_2', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_town_city'}
                        detailedLabel={'Town / City'}
                        value={data.residential_town_city}
                        type={'text'}
                        onChange={(value) => onChange('residential_town_city', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        name={'residential_state_county'}
                        detailedLabel={'County / State'}
                        value={data.residential_state_county}
                        type={'text'}
                        onChange={(value) => onChange('residential_state_county', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_postcode'}
                        detailedLabel={'Postcode'}
                        value={data.residential_postcode}
                        type={'text'}
                        onChange={(value) => onChange('residential_postcode', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_country'}
                        detailedLabel={'Country'}
                        value={data.residential_country}
                        type={'select'}
                        options={COUNTRY_OPTIONS}
                        onChange={(value) => onChange('residential_country', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <DetaileddetailedLabel detaileddetailedLabel={'Occupied this Address Since'} style={{paddingLeft: 0}}/>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_occupied_since_year'}
                        detailedLabel={'Year'}
                        value={data.residential_occupied_since_year}
                        type={'select'}
                        options={YEAR_OPTIONS}
                        onChange={(value) => onChange('residential_occupied_since_year', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'residential_occupied_since_month'}
                        detailedLabel={'Month'}
                        value={data.residential_occupied_since_month}
                        type={'select'}
                        options={MONTH_OPTIONS}
                        onChange={(value) => onChange('residential_occupied_since_month', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                required={true}
                name={'permanent_address_is_correspondence_address'}
                detailedLabel={'Do you want your permanent residential address to be your correspondence address?'}
                value={data.permanent_address_is_correspondence_address}
                type={'select'}
                options={BOOLEAN_OPTIONS}
                onChange={(value) => onChange('permanent_address_is_correspondence_address', value)}
                disabled={disabled}
                error={errors}
            />
        </React.Fragment>
    );
}

export default ResidentialAddressDetails;
